import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';
import FacebookButton from '../../containers/facebook-button.container';
import FormField from '../form-field';
import '../../css/embedded-signin.css';

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      password: null,
    };

    this.onEmailChange = this.onEmailChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onSendLink = this.onSendLink.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHideClick = this.onHideClick.bind(this);
  }

  onEmailChange(ev) {
    this.setState({ email: ev.target.value });
    this.props.onEmailChange(ev.target.value);
  }

  onHideClick() {
    this.props.onHideClick();
  }

  onPasswordChange(ev) {
    this.setState({ password: ev.target.value });
  }

  onSendLink() {
    const { email } = this.state;
    this.props.onSendLink(email);
  }

  onSubmit() {
    return this.props.onSubmit({
      email: this.getEmailFromField(),
      password: this.getPasswordFromField(),
    });
  }

  getClassName() {
    const { method } = this.props;
    if (method === 'facebook') return 'with-facebook';
    if (method === 'guest') return 'as-guest';
    return '';
  }

  getEmailFromField() {
    return this.emailField.value;
  }

  getPasswordFromField() {
    return this.passwordField.value;
  }

  renderAuthenticationMethod() {
    const { method } = this.props;
    if (method === 'facebook') return this.renderFacebookButton();
    if (method === 'guest') return this.renderGuestLink();
    return this.renderPasswordField();
  }

  renderEmailField() {
    return (
      <div className="col-5">
        <Field
          name="email"
          type="email"
          component={FormField}
          label={
            <FormattedMessage
              id="commitForm.signin.emailField.label"
              defaultMessage="Email"
            />
          }
          className="email-input"
          ref={(el) => { this.emailField = el; }}
          onChange={this.onEmailChange}
        />
      </div>
    );
  }

  renderFacebookButton() {
    return (
      <div className="col-7">
        <FacebookButton>
          <FormattedMessage
            id="commitForm.signin.facebookButton"
            defaultMessage="Facebook Connect"
          />
        </FacebookButton>
      </div>
    );
  }

  renderGuestLink() {
    return (
      <div className="col-7">
        <div className="form-group">
          <p className="pt-4">
            <sub className="small-print coral-error">
              <FormattedMessage
                id="commitForm.signin.alreadyJoined.asGuest"
                defaultMessage="You already joined as a guest.
                  To update your contribution, you must verify your email."
              />
              <button
                type="button"
                className="btn-link send-guest-link"
                onClick={this.onSendLink}
              >
                <FormattedMessage
                  id="commitForm.signin.sendLink"
                  defaultMessage="Send me a link to authenticate."
                />
              </button>
            </sub>
          </p>
        </div>
      </div>
    );
  }

  renderPasswordField() {
    return (
      <div className="col-7">
        <div className="row">
          <div className="col-7">
            <small className="pull-right">
              <a
                tabIndex="-1"
                href="/password-reset"
                className="btn-link btn-sm d-inline-block px-0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="commitForm.signin.forgotPassword"
                  defaultMessage="Forgot?"
                />
              </a>
            </small>
            <Field
              name="password"
              type="password"
              component={FormField}
              onChange={this.onPasswordChange}
              ref={(el) => { this.passwordField = el; }}
              label={
                <FormattedMessage
                  id="commitForm.signin.passwordField.label"
                  defaultMessage="Password"
                />
              }
            />
          </div>
          <div className="col-5">
            <button
              type="button"
              onClick={this.onSubmit}
              className="btn btn-primary"
            >
              <FormattedMessage
                id="commitForm.signin.signinButton"
                defaultMessage="Sign in"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderSubtext() {
    const { method } = this.props;
    if (method === 'facebook') {
      return (
        <div className="col-12 small-print email-field-subtext facebook-subtext">
          <FormattedMessage
            id="commitForm.signin.alreadyJoined.withFacebook"
            defaultMessage="You already connected to Key Travel using Facebook"
          />
        </div>
      );
    }
    if (method === 'guest') {
      return (
        <div className="col-12 small-print email-field-subtext guest-subtext">
          <FormattedMessage
            id="commifForm.signing.haveGuestAccount"
            defaultMessage="You have a guest account."
          />
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <div className={`embedded-signin signin ${this.getClassName()}`}>
        <div>
          <div className="row mb-2">
            <div className="col-12">
              <FormattedMessage
                id="commitForm.signin.nevermind"
                defaultMessage="Oops! Nevermind"
              />
              {' '}
              <button type="button" className="btn-link no-account" onClick={this.onHideClick}>
                <FormattedMessage
                  id="commitForm.signin.dontHaveAccount"
                  defaultMessage="I don’t have an account"
                />
              </button>
            </div>
          </div>
          <div className="row">
            {this.renderEmailField()}
            {this.renderAuthenticationMethod()}
          </div>
          <div className="row">
            {this.renderSubtext()}
          </div>
        </div>
      </div>
    );
  }
}

SignIn.defaultProps = {
  method: 'email',
  onEmailChange: () => {},
  onHideClick: () => {},
  onSendLink: () => {},
  onSubmit: () => {},
};

export default SignIn;



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/signin.js